<template>
  <section
    :class="sectionBgClass"
    class="w-full overflow-hidden"
  >
    <div :class="[data?.containerFull ? 'w-full' : 'container px-4']">
      <!-- Title -->
      <UiHeading
        v-if="data?.heading"
        :pin="data?.heading?.pin"
        :title="data?.heading?.title"
        :description="data?.heading?.description"
        :button="data?.heading?.button"
        :color="data?.heading?.color"
        :position="data?.heading?.position"
        v-aos="animate && 'zoom-out'"
      />
      <!-- Title -->

      <!-- Download -->
      <div v-aos="animate && 'fade-up'" class="flex flex-col gap-4">
        <template
          v-for="(item, itemKey) in data?.items"
          :key="item?.id || itemKey"
        >
          <UiDownload
            v-if="item?.enabled"
            :index="itemKey"
            :pin="item?.pin"
            :title="item?.title"
            :file="item?.file"
          />
        </template>
      </div>
      <!-- Download -->

      <!-- Button -->
      <div
        v-if="data?.showMoreLink && data?.showMoreLink?.length > 0"
        class="flex mt-4 md:mt-6 lg:mt-8 xl:mt-10 justify-center"
      >
        <AtomsButton
          :label="$t('Show More')"
          :link="data?.showMoreLink"
          :color="buttonColor"
          size="small"
          :enabled="true"
          class="uppercase"
        />
      </div>
      <!-- Button -->
    </div>
  </section>
</template>
<script setup>
import { computed } from "vue";
import { useIsMobile } from "~/composables/utils";
import { sectionOuterSpacingClass } from "~/composables/sectionSpacing";
const props = defineProps({
  data: { type: Object },
  animate: { type: Boolean, default: false },
});

const { isMobile } = useIsMobile();
const sectionBgClass = computed(() => {
  let bg = '';
  const bgColor = props.data?.backgroundColor;
  if (bgColor === 'first') bg = 'bg-brand-first' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'second') bg = 'bg-brand-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'third') bg = 'bg-brand-third' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'dark-first') bg = 'bg-brand-dark' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'dark-second') bg = 'bg-brand-dark-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'light-first') bg = 'bg-brand-light' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'light-second') bg = 'bg-brand-light-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  return [bg, sectionOuterSpacingClass(props.data)];
});

const buttonColor = computed(() => props.data?.heading?.color === 'white' ? 'white-outline' : 'black-outline');
</script>
